// extracted by mini-css-extract-plugin
export default {"container":"Sp-z","bubbleNav":"Tp-z","graphic":"Up-z","contact":"Vp-z"};